import { Alert } from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import ContinueWithPassword from 'components/continue-with-password/continue-with-password.component';
import { useTranslation } from 'react-i18next';

const MagicLinkConfirmation = ({ send, destination, isNewUser }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Alert severity="info">
        {t('passwordless.magicLinkConfirmation.banner', { destination })}
      </Alert>
      <Box display="grid" rowGap={theme => theme.spacing(1)}>
        <Typography variant="body2">
          {t('passwordless.magicLinkConfirmation.didntReceive')}
        </Typography>
        <ContinueWithPassword send={send} isNewUser={isNewUser} />
      </Box>
    </Stack>
  );
};

export default MagicLinkConfirmation;
